import { Center } from '@mantine/core';
import Lottie from 'lottie-react';
import React from 'react';
import animation from '../../assets/json/Loader.json';

const Loader = () => (
  <Center style={{ width: '100vw', height: '100vh', position: 'absolute', zIndex: 9999 }}>
    <Lottie animationData={animation} loop />
  </Center>
);

export default Loader;
